/*产品展示item*/
import { getCatlogsAction } from '@ivymobi/orbit-core/business/productCenter';
import { filter, isUndefined, union } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TenantContext, UserContext } from '../../orbit-context';
import { Loading } from '../../components';
import {
  Box,
  Divider,
  Grid,
  IconButton,
  Theme,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import './selectionItem.css';
import { MoreHoriz } from '@mui/icons-material';
import _ from 'lodash';
import { getProductImage } from '@ivymobi/orbit-core';
const OptionControlPanel = (props) => {
  const {data,setModeOptions,modeOptions,getCgId,cardInfos} = props;
  const  {robot,robotOptions,control,controlOptions} = modeOptions
  console.log("datadatadatadata=======,",data)
  const addControlOption = (cgId,row)=>{
    if(cgId===getCgId(cardInfos,'机器人选件')){
      let rbOption = [...(robotOptions??[])]
      rbOption.push(row);
      setModeOptions({ ...modeOptions, robotOptions: rbOption },33);
    }else if(cgId===getCgId(cardInfos,'控制器选件')){
      let rbOption = [...(controlOptions??[])]
      rbOption.push(row);
      setModeOptions({ ...modeOptions, controlOptions: rbOption },34);
    }

  }
  return (
    <Box style={{height:"100%",background:'white',padding:'20px',display:'flex',flexDirection:'column'}}>
      {data.length==0&&<Box style={{width:'100%',textAlign:'center',fontSize:'17px'}}>
        暂无匹配的产品
        </Box>}
      {data.map((item,i)=>{
        if(item.productsData?.length==0)
          return null
        return (
          <><Box style={{ fontSize: '17px', paddingLeft: '10px', paddingTop: i==0?'0px':'30px' }}>{item.cgName?.zh}</Box><Box style={{ background: 'white', flexGrow: '1' }}>
            <Box style={{ overflow: 'auto', height: '100%' }}>
              <Table stickyHeader>
                <TableHead> 
                  <TableRow>
                    <TableCell style={{ backgroundColor: 'white' }}>名称</TableCell>
                    <TableCell style={{ backgroundColor: 'white' }} align="center">型号</TableCell>
                    <TableCell style={{ backgroundColor: 'white' }} align="center">规格</TableCell>
                    <TableCell style={{ backgroundColor: 'white' }} align="center">图片</TableCell>
                    <TableCell style={{ backgroundColor: 'white' }} align="right">操作</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {item.productsData?.map((row) => { return (
                    <TableRow key={row.name}>
                      <TableCell component="th" scope="row">
                      {_.get(row, 'details.descriptionShort.zh')}
                      </TableCell>
                      <TableCell align='center'>{row.featuresDic['IF000002']?.fvalue}</TableCell>
                     
                      <TableCell align='center'>{row.featuresDic['IF000015']?.fvalue}</TableCell>
                      <TableCell align='center'><img src={getProductImage(row?.mime)} style={{width:'45px',height:'45px'}}/></TableCell>

                      
                      <TableCell align="right">
                        <Button variant='contained'
                          style={{ background: '#ece8e8', color: 'red', width: '150px' }}
                          onClick={() => {
                            row.bSelect = !row.bSelect;
                            addControlOption(item.real_cgId,row)
                            // postModelOptions({ ...modeOptions, controlOptions: row });
                            // setRobotSelect(row);
                          } }
                        >
                          {row.bSelect?'已加入 -':'加入选型清单 +'}
                        </Button>
                      </TableCell>
                    </TableRow>
                  )})}
                </TableBody>
              </Table>
            </Box>

          </Box></>
        )
      })}
      


    </Box>
    ); 
};
const useStyles = makeStyles((theme: Theme) => createStyles({
 
  item:{
    background:'#fbfbfb',
    marginRight:'20px' ,
    padding:'9px',
    margin:'3px'  
  },
  selectItem:{
    background:'#fbf1f1',
    marginRight:'20px' ,
    padding:'9px',
    margin:'3px',
    border:'1px solid #f28f90!important'
  }


}));

export default OptionControlPanel;